/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export const MONTH_SHORT_NAME_LIST_MLS: {
  [monthNumber: number]: string;
} = {
  1: 'lbl_january_middle',
  2: 'lbl_february_middle',
  3: 'lbl_march_middle',
  4: 'lbl_april_middle',
  5: 'lbl_may_middle',
  6: 'lbl_june_middle',
  7: 'lbl_july_middle',
  8: 'lbl_august_middle',
  9: 'lbl_september_middle',
  10: 'lbl_october_middle',
  11: 'lbl_november_middle',
  12: 'lbl_december_middle',
};

export const MONTH_NAME_LIST_MLS: {
  [monthNumber: number]: string;
} = {
  1: 'lbl_january',
  2: 'lbl_february',
  3: 'lbl_march',
  4: 'lbl_april',
  5: 'lbl_may',
  6: 'lbl_june',
  7: 'lbl_july',
  8: 'lbl_august',
  9: 'lbl_september',
  10: 'lbl_october',
  11: 'lbl_november',
  12: 'lbl_december',
};
